document.addEventListener('DOMContentLoaded', function () {
  const logoWrapper = document.querySelector('.video-section__logo');
  const section = document.querySelector('.video-section');
  const headerLogo = document.querySelector('.section-header .header__heading-logo');
  const headerWrapper = document.querySelector('.header-wrapper');
  const sectionHeader = document.querySelector('.section-header');

  if (!logoWrapper || !section || !headerLogo || !headerWrapper || !sectionHeader) return;

  gsap.registerPlugin(ScrollTrigger);

  const heroLogoRect = logoWrapper.getBoundingClientRect();
  const headerLogoRect = headerLogo.getBoundingClientRect();

  const heroWidth = heroLogoRect.width;
  const headerWidth = headerLogoRect.width;

  const targetScale = headerWidth / heroWidth;
  const targetY = -((heroLogoRect.bottom - headerLogoRect.bottom) * 0.6);

  gsap.fromTo(
    logoWrapper,
    { opacity: 1, y: 0, scale: 1 },
    { opacity: 1, y: 0, scale: 1, duration: 1, ease: 'power2.out' }
  );

  gsap.to(logoWrapper, {
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: 'bottom top',
      scrub: 1.2,
      ease: 'power1.out',
    },
    scale: targetScale,
    y: targetY,
    ease: 'none',
  });

  window.addEventListener('scroll', () => {
    const logoRect = logoWrapper.getBoundingClientRect();
    const sectionRect = section.getBoundingClientRect();

    if (logoRect.top <= 0) {
      headerWrapper.classList.remove('invisible-header');
      sectionHeader.classList.add('section-header-hovered');
    } else {
      headerWrapper.classList.add('invisible-header');
      sectionHeader.classList.remove('section-header-hovered');
    }

    if (sectionRect.bottom <= 0 || sectionRect.top >= window.innerHeight) {
      sectionHeader.classList.remove('section-header-hovered');
    }
  });
});
